import { render, staticRenderFns } from "./ot-pagination-wrapper.vue?vue&type=template&id=44863225&scoped=true&"
import script from "./ot-pagination-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-pagination-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-pagination-wrapper.vue?vue&type=style&index=0&id=44863225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44863225",
  null
  
)

export default component.exports